import { setLogLevel } from "@kform/core";

declare global {
  /**
   * Sets the logging level associated with KForm's form managers.
   *
   * This global function is only available in non-production environments.
   * Import {@link setLogLevel} from `@kform/core` directly otherwise.
   */
  var setKFormLogLevel: typeof setLogLevel | undefined;
}

// When not in production, expose a way of changing KForm's log level from the
// browser dev tools
if (process.env.NODE_ENV !== "production") {
  globalThis.setKFormLogLevel ??= setLogLevel;
}
